import i18n from '@/i18n';
import moment from 'moment';

import { validateAllField } from '@/utils/validate';
import { STR_DATE_TIME } from '@/utils/format';

function handleValidate(initForm) {
    let check = validateAllField(initForm);
    const startDate = moment(initForm.configFieldStartDate.valueSync, STR_DATE_TIME);
    const endDate = moment(initForm.configFieldEndDate.valueSync, STR_DATE_TIME);
    if (!endDate.isSameOrAfter(startDate)) {
        check = false;
        initForm.configFieldEndDate.error = true;
        initForm.configFieldEndDate.errorText = i18n.t('validateField.compareDate');
    }
    return check;
}

function validateEndDate(configField, startDateStr, endDateStr) {
    const startDate = moment(startDateStr, STR_DATE_TIME);
    const endDate = moment(endDateStr, STR_DATE_TIME);
    if (!endDate.isSameOrAfter(startDate)) {
        configField.error = true;
        configField.errorText = i18n.t('validateField.compareDate');
    }
}

function initForm() {
    return {
        start_date_cp_full_date: '',
        start_date_cp_full_time: '',
        configFieldStartDate: {
            valueSync: '',
            error: false,
            typesValidate: ['requiredDate', 'dateTime'],
            errorField: i18n.t('sheduleFile.startDateCP'),
            errorText: ''
        },

        end_date_cp_full_date: '',
        end_date_cp_full_time: '',
        configFieldEndDate: {
            valueSync: '',
            error: false,
            typesValidate: ['requiredDate', 'dateTime'],
            errorField: i18n.t('sheduleFile.endDateCP'),
            errorText: ''
        },

        date_shipping_year: '',
        date_shipping_month: '',
        date_shipping_day: '',
        date_shipping_full_date: '',
        configFieldDateShipping: {
            valueSync: '',
            error: false,
            typesValidate: ['requiredDate', 'date'],
            errorField: i18n.t('sheduleFile.dateShipping'),
            errorText: ''
        },

        end_date_secretariat_full_date: '',
        end_date_secretariat_full_time: '',
        configFieldEndDateSecretariat: {
            valueSync: '',
            error: false,
            typesValidate: ['requiredDate', 'dateTime'],
            errorField: i18n.t('sheduleFile.endDateSecretariat'),
            errorText: ''
        },

        type_application: [],
        listApplication: []
    };
}

const TAB_SCHEDULE = () => [
    {
        id: 1,
        name: i18n.t('document.schedule'),
        disabled: false
    },
    {
        id: 2,
        name: i18n.t('document.mumberOfMessagesFMT'),
        disabled: false
    },
    {
        id: 3,
        name: i18n.t('document.contactFMT'),
        disabled: false
    }
];

export { handleValidate, initForm, validateEndDate, TAB_SCHEDULE };
